import { render, staticRenderFns } from "./List137.vue?vue&type=template&id=6985d06f&"
import script from "./List137.vue?vue&type=script&lang=js&"
export * from "./List137.vue?vue&type=script&lang=js&"
import style0 from "./List137.vue?vue&type=style&index=0&id=6985d06f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports